import { useMemo, useRef, useState } from "react";
import { LayoutContentContext } from "../../contexts/LayoutContentContext";

const LayoutContentContainer = ({ children }) => {
  const [overlayNode, setOverlayNode] = useState(null);
  const contentRef = useRef(null);

  const value = useMemo(() => ({ overlayNode, contentRef }), [overlayNode]);

  return (
    <LayoutContentContext.Provider value={value}>
      <div
        id="layout-content-container"
        ref={contentRef}
        className="relative flex-1 min-h-0 min-w-0 flex flex-col"
      >
        {/* min-w-0 (here and on the inner column) lets this flex item shrink to
            its flex-1 share instead of growing to fit wide children. Without it,
            a wide child such as the CustomTabs roof/facade strip pushes this
            column past the viewport (SPRIN-651). */}
        <div className="flex flex-col overflow-auto custom-scrollbar flex-1 min-h-0 min-w-0 z-[1]">
          {children}
        </div>
        <div
          id="layout-content-overlay"
          ref={setOverlayNode}
          className="pointer-events-none absolute inset-0 z-[2]"
        />
      </div>
    </LayoutContentContext.Provider>
  );
};

export default LayoutContentContainer;
